// import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
// import performanceService from "./performanceService";

// export const getPerformance = createAsyncThunk(
//   "performance/get-performance",
//   async (filters, thunkAPI) => {
//     try {
//       return await performanceService.getPerformance(filters);
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error);
//     }
//   }
// );

// export const updatePerformanceStatus = createAsyncThunk(
//   "performance/update-status",
//   async ({ id, status }, thunkAPI) => {
//     try {
//       return await performanceService.updatePerformanceStatus(id, status);
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error);
//     }
//   }
// );

// export const resetState = createAction("Reset_all");

// const initialState = {
//   performances: [],
//   isError: false,
//   isLoading: false,
//   isSuccess: false,
//   message: "",
// };

// export const performanceSlice = createSlice({
//   name: "performance",
//   initialState,
//   reducers: {},
//   extraReducers: (builder) => {
//     builder
//       .addCase(getPerformance.pending, (state) => {
//         state.isLoading = true;
//       })
//       .addCase(getPerformance.fulfilled, (state, action) => {
//         state.isLoading = false;
//         state.isError = false;
//         state.isSuccess = true;
//         state.performances = action.payload;
//       })
//       .addCase(getPerformance.rejected, (state, action) => {
//         state.isLoading = false;
//         state.isError = true;
//         state.isSuccess = false;
//         state.message = action.error;
//       })
//       .addCase(updatePerformanceStatus.pending, (state) => {
//         state.isLoading = true;
//       })
//       .addCase(updatePerformanceStatus.fulfilled, (state, action) => {
//         state.isLoading = false;
//         state.isError = false;
//         state.isSuccess = true;
//         state.performances = state.performances.map((perf) =>
//           perf._id === action.meta.arg.id
//             ? { ...perf, status: action.meta.arg.status }
//             : perf
//         );
//       })
//       .addCase(updatePerformanceStatus.rejected, (state, action) => {
//         state.isLoading = false;
//         state.isError = true;
//         state.isSuccess = false;
//         state.message = action.error;
//       })
//       .addCase(resetState, () => initialState);
//   },
// });

// export default performanceSlice.reducer;

import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import performanceService from "./performanceService";

export const getPerformance = createAsyncThunk(
  "performance/get-performance",
  async (filters, thunkAPI) => {
    try {
      return await performanceService.getPerformance(filters);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updatePerformanceStatus = createAsyncThunk(
  "performance/update-status",
  async ({ id, status }, thunkAPI) => {
    try {
      return await performanceService.updatePerformanceStatus(id, status);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const resetState = createAction("Reset_all");

const initialState = {
  performances: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};

export const performanceSlice = createSlice({
  name: "performance",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPerformance.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPerformance.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.performances = action.payload;
      })
      .addCase(getPerformance.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error.message || "Failed to fetch performances";
      })
      .addCase(updatePerformanceStatus.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updatePerformanceStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        // Update the specific performance with the full API response
        state.performances = state.performances.map((perf) =>
          perf._id === action.payload._id ? action.payload : perf
        );
      })
      .addCase(updatePerformanceStatus.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error.message || "Failed to update status";
      })
      .addCase(resetState, () => initialState);
  },
});

export default performanceSlice.reducer;
